import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "acted-indicator",
  title: "Действие выполнено"
}
const _hoisted_2 = { class: "player-name" }
const _hoisted_3 = {
  key: 1,
  class: "emote-wrapper"
}
const _hoisted_4 = {
  key: 2,
  class: "team-indicators"
}
const _hoisted_5 = ["onMouseenter", "onClick"]
const _hoisted_6 = {
  key: 3,
  class: "dead-overlay"
}

import { computed, ref } from 'vue';
import { useGameStore } from '@/stores/gameStore';
import { useUserStore } from '@/stores/userStore';
import type { PlayerPublic } from '@/types/game';
import Tooltip from '@/views/ui/ToolTip.vue';

interface Indicator {
    voterName: string;
    isConfirmed: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PlayerCard',
  props: {
    player: {},
    isSelectable: { type: Boolean },
    isSelected: { type: Boolean }
  },
  setup(__props: any) {

const showTooltip = ref(false);
const tooltipText = ref('');
const tooltipTarget = ref<HTMLElement | null>(null);
let hideTooltipTimeout: number;

const showDotTooltip = (event: MouseEvent, indicator: Indicator) => {
    clearTimeout(hideTooltipTimeout);
    tooltipTarget.value = event.currentTarget as HTMLElement;
    const actionText = indicator.isConfirmed ? 'выбрал' : 'хочет выбрать';
    tooltipText.value = `Игрок ${indicator.voterName} ${actionText} эту цель`;
    showTooltip.value = true;
};

const hideTooltip = () => {
    hideTooltipTimeout = window.setTimeout(() => {
        showTooltip.value = false;
    }, 100);
};

const props = __props;
const gameStore = useGameStore();
const userStore = useUserStore();
const isMyCard = computed(() => props.player.name === userStore.playerName);
const isTeamTarget = computed(() => gameStore.getVotersForPlayer(props.player.name).length > 0);
const sendEmote = () => gameStore.sendEmote(props.player.name);

const indicators = computed(() => {
    const allIndicators = gameStore.teamActivity[props.player.name] || [];
    return allIndicators.filter(indicator => indicator.voterName !== userStore.playerName);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["player-card", {
        'is-dead': !_ctx.player.is_alive,
        'is-selectable': _ctx.isSelectable,
        'is-selected': _ctx.isSelected,
        'is-me': isMyCard.value,
    }])
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-border" }, null, -1)),
    (_ctx.player.has_acted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "player-avatar" }, [
      _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor"
      }, [
        _createElementVNode("path", { d: "M12 2C9.243 2 7 4.243 7 7s2.243 5 5 5 5-2.243 5-5S14.757 2 12 2zM12 14c-3.86 0-7 3.14-7 7h14c0-3.86-3.14-7-7-7z" })
      ])
    ], -1)),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.player.name), 1),
    (_ctx.player.is_alive && !isMyCard.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _withModifiers(sendEmote, ["stop"]),
            class: "emote-btn",
            title: "Подмигнуть"
          }, "👁️")
        ]))
      : _createCommentVNode("", true),
    (indicators.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(indicators.value, (indicator) => {
            return (_openBlock(), _createElementBlock("div", {
              key: indicator.voterName,
              class: _normalizeClass(["indicator-dot", { 'is-confirmed': indicator.isConfirmed }]),
              onMouseenter: ($event: any) => (showDotTooltip($event, indicator)),
              onMouseleave: hideTooltip,
              onClick: _withModifiers(($event: any) => (showDotTooltip($event, indicator)), ["stop"])
            }, _toDisplayString(indicator.voterName.charAt(0).toUpperCase()), 43, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.player.is_alive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[0] || (_cache[0] = [
          _createElementVNode("span", null, "ВЫБЫЛ", -1)
        ])))
      : _createCommentVNode("", true),
    _createVNode(Tooltip, {
      show: showTooltip.value,
      text: tooltipText.value,
      "target-element": tooltipTarget.value
    }, null, 8, ["show", "text", "target-element"])
  ], 2))
}
}

})